import { Region } from "../../constants/action-constants/RegionActionConstants";

export const getRegionDataByCity = (cityId) => ({
  type: Region.GET_REGION_DATA_BY_CITY,
  payload: { cityId },
});

export const clearRegionDataByCity = () => ({
  type: Region.CLEAR_REGION_DATA_BY_CITY,
});

export const getRegionNames = () => ({
  type: Region.GET_REGION_NAMES,
});

export const getPincodeRankingByTg = (cityId, tgAttrMap) => ({
  type: Region.GET_PINCODE_RANKING_BY_TG,
  payload: { cityId, tgAttrMap },
});

export const clearPincodeRankingByTg = () => ({
  type: Region.CLEAR_PINCODE_RANKING_BY_TG,
});

export const selectTgAttrForRanking = (attrGroup, attrName) => ({
  type: Region.SELECT_TG_ATTR_FOR_RANKING,
  payload: { attrGroup, attrName },
});

export const unSelectTgAttrForRanking = (attrGroup, attrName) => ({
  type: Region.UNSELECT_TG_ATTR_FOR_RANKING,
  payload: { attrGroup, attrName },
});
